export default "__VITE_ASSET__DMGhsvha__"